module.exports = __webpack_public_path__ + "static/img/product21.5afa1aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product21.png
// module id = v0cx
// module chunks = 13